export default __webpack_public_path__ + "static/media/PayPal1.c095572b.svg";